import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EditorService } from 'src/app/services/editor.service';
import { InputEditorComponent } from '../input/input-editor/input-editor.component';

@Component({
  selector: 'document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss']
})
export class DocumentPreviewComponent implements OnInit {
  @ViewChild(InputEditorComponent) editor?: InputEditorComponent;
  @Input() html?: string;
  @Input() emptyDocumentMensage?: string;
  @Input() noMargin?: string;

  public formFake = new FormGroup({});
  public editorService:EditorService;

  constructor(public injector:Injector) { 
    //super(injector);
    this.editorService = injector.get<EditorService>(EditorService);
  }

  ngOnInit(): void {
  }

  public get isNoMargin(): boolean {
    return this.noMargin != undefined;
  }

  public print() {
    this.editor?.print();
  }

}
